import { atom } from 'recoil';

/** SMS 인증번호 */
export const SmsOtpAtom = atom<string>({
  key: 'SmsOtpAtom',
  default: ''
});
